import { SynDialogConfig, ConfirmModalComponent } from '$synapse/core';
import { Candidate } from '$synapse/models';
import { CandidateService } from '$synapse/services';
import { Component, Input, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { CandidateUpdateModalComponent } from '../../candidates/candidate-update-modal/candidate-update-modal.component';
import { GroupSummary } from '$synapse/dtos';
import { MatDialog } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '../../../core/shared-imports';

@Component({
  selector: 'syn-candidate-description-card',
  templateUrl: './candidate-description-card.component.html',
  styleUrls: ['./candidate-description-card.component.scss'],
  imports: [SHARED_IMPORTS],
})
export class CandidateDescriptionCardComponent implements OnInit {
  private readonly _modalDialog = inject(MatDialog);
  private readonly _candidateService = inject(CandidateService);
  private readonly _router = inject(Router);
  private readonly _toastr = inject(ToastrService);

  @Input() candidate: Candidate;
  groupsSummary: GroupSummary[];

  ngOnInit(): void {
    this._getGroups();
  }

  deleteCandidate() {
    const dialogRef = this._modalDialog.open(
      ConfirmModalComponent,
      new SynDialogConfig('delete-candidate-confirmation')
    );
    const instance = dialogRef.componentInstance;
    instance.title = "Suppression d'un candidat";
    instance.message = 'Êtes-vous sûr de vouloir supprimer ce candidat ?';
    instance.action = 'Supprimer';
    instance.warn = 'Attention ! Toutes ses évaluations seront supprimées';
    instance.confirmationEvent.subscribe(() => {
      this._candidateService.remove(this.candidate.id).subscribe(() => {
        this._toastr.success(
          `Le candidat ${this.candidate.firstName} ${this.candidate.lastName} a bien été supprimé.`,
          'Suppression réussie'
        );
        this._router.navigate(['/candidates'], {
          queryParamsHandling: 'merge',
        });
      });
    });
  }

  modifyCandidate() {
    const dialogRef = this._modalDialog.open(
      CandidateUpdateModalComponent,
      new SynDialogConfig('modal-assessment-component', this.candidate)
    );

    dialogRef.afterClosed().subscribe((candidate: Candidate) => {
      if (candidate) {
        this.candidate = candidate;
        this._getGroups();
      }
    });
  }

  private _getGroups() {
    if (this.candidate.groups) {
      this.groupsSummary = this.candidate.groups;
    } else {
      this.groupsSummary = null;
    }
  }
}
